

import React from 'react'
import WooCommData from '../components/woocomm-data.js'
import WooPlanTable from '../components/woocom-plan.js'
import usePageMeta from '../hooks/usePageMeta';
export default function WooCommerce() {
    usePageMeta('WooCommerce Store Development & CRO | Spinnennetz', 'Build a high-converting WooCommerce store with Spinnennetz. Custom WordPress eCommerce development designed to grow revenue and scale your online brand.', '/woocommerce', {"@context":"https://schema.org","@type":"Service","name":"WooCommerce Store Development & CRO","provider":{"@type":"Organization","name":"Spinnennetz"}}, 'WooCommerce development services, custom WooCommerce store setup, WordPress ecommerce developer, WooCommerce optimization');
    return (
        <>
            <WooCommData />
            <WooPlanTable />
        </>
    )
}
